import {
  GqlInvalidContentReason,
  GqlUpsertTemplateInvalidContentFailureTypes,
} from 'modules/templateEditor/common';

/**
 * Omits unsubscribe URL validation errors when the `TemplateDisableUnsubscribeUrlValidation` feature flag is enabled
 *
 * Background: Previously in angular experience,
 * we had a bug in which even though we were showing missing unsubscribe URL errors
 * we didn't prevent clients from scheduling campaigns. Wolt took advantage of it.
 * So they are reluctant move to new experience since they have to fix lot of templates
 * in order to even schedule a campaign.
 * @see https://iterable.atlassian.net/browse/CAMP-1259
 * @see https://iterable.slab.com/posts/camp-1259-spike-research-works-for-adding-wolt-onto-a-feature-flag-for-unsubscribe-url-validations-u1b3hs2y
 *
 */
export const getAllowedValidationFailures = (
  validationFailures: GqlInvalidContentReason[],
  omitUnsubscribeUrlErrorFlag: boolean,
) => {
  return validationFailures.filter(({ __typename }) => {
    if (omitUnsubscribeUrlErrorFlag) {
      return __typename !== GqlUpsertTemplateInvalidContentFailureTypes.MISSING_UNSUBSCRIBE_URL;
    }

    return true;
  });
};
